import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=48796bb6&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=ts"
export * from "./SaveButton.vue?vue&type=script&lang=ts"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=48796bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48796bb6",
  null
  
)

export default component.exports